import { useState, useMemo, useCallback } from 'react'
import { AttorneyData } from '../../../dtos/applicationData'
import { useApplication } from '../../../context/application'
import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  DefaultTitle,
  DefaultSubtitle,
} from '../../../components/application/defaultComponents'
import ApplicationPrebuiltFooter from '../../../components/application/PrebuiltBodyFooter'
import NewAttorneysForm from 'src/components/application/mainPagesComponents/Attorneys/NewForm'
import { AttorneyMainSchema } from 'src/yup/NewAppSchema'

const newAttorneyData = {
  firstName: '',
  lastName: '',
}

const Main = () => {
  const newAttorneyErrorCodes = ['EC221', 'EC222', 'EC223', 'EC224', 'EC225', 'EC226', 'EC227', 'EC228', 'EC229',
                                 'EC230', 'EC231', 'EC232', 'EC233', 'EC234', 'EC235', 'EC236', 'EC237', 'EC238',
                                 'EC261', 'EC262', 'EC330', 'EC331', 'EC332', 'EC333', 'EC334']
  const { application, saveApplication } = useApplication()
  const [attorneys, setAttorneys] = useState<AttorneyData[]>(() => {
    return application?.attorneysSection?.attorneys ?? [newAttorneyData]
  })

  const [displayErrors, setDisplayErrors] = useState(false)
  const [/*disableSaveandContinue*/, setDisableSaveandContinue] = useState(false)



  function freshCheckIsFormValid() {
    return Object.keys(validationPerAttorney).every(key => validationPerAttorney[key] === true)
  }

  const validateAttorney = useCallback((attorney: AttorneyData) => {
    try {
      AttorneyMainSchema.validateSync(attorney)
      return true
    } catch (e) {
      return false
    }
  }, []);

  const validationPerAttorney = useMemo(() => {
    let validatedAttorney: { [key: string]: boolean } = {}

    for (let index = 1; index <= attorneys.length; index++) {
      validatedAttorney[`att__${index}`] = validateAttorney(attorneys[index - 1])
    }
    return validatedAttorney
  }, [attorneys, validateAttorney])

  const updatedApplicationData = () => ({
    ...application,
    currentPage: window.location.pathname,
    attorneysSection: { ...application.attorneysSection, attorneys }
  })

  const goBackRoute = () => {
      if (application.firmSection?.relationships?.hasSuedClientForFees)
          return '/firm/loss-prevention'

    return '/firm/relationships'
  }

  const handleScrollOnMissingData = () => {
    for (let [key, isValid] of Object.entries(validationPerAttorney)) {
      if (!isValid) {
        document.getElementById(key)?.scrollIntoView({ behavior: 'smooth' })
        setDisplayErrors(true)
        break
      }
    }
  }

  const handleSaveDetails = async () => {
    handleIsFormValid()
    await saveApplication(updatedApplicationData())
  }

  const handleIsFormValid = () => {
    let isValid = Object.keys(validationPerAttorney).every(key => validationPerAttorney[key] === true)

    if (isValid) {
      setDisableSaveandContinue(false)
    } else {
      setDisableSaveandContinue(true)
    }
  }

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Please add all attorneys currently in {application?.firmSection?.firmName ?? ''}.</DefaultTitle>
        <DefaultSubtitle>
          Please include all independent contractors and of counsel attorneys.
        </DefaultSubtitle>
        <NewAttorneysForm
          attorneys={attorneys}
          setAttorneys={setAttorneys}
          handleSaveDetails={handleSaveDetails}
          showErrors={displayErrors}
          setDisableSaveandContinue={setDisableSaveandContinue}
          isAttorneyVerification={false}
          disableAddNewAttorneys={!freshCheckIsFormValid()}
          errorCodes={newAttorneyErrorCodes}
        />
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute={goBackRoute()}
        isFormValid={Object.keys(validationPerAttorney).every(key => validationPerAttorney[key] === true)}
        nextRoute="/attorneys/relationships"
        updatedApplication={updatedApplicationData()}
        beforeSaveContinueClick={handleScrollOnMissingData}
        // disableSaveandContinue={disableSaveandContinue}
      />
    </ApplicationBodyContainer>
  )
}

export default Main